// extracted by mini-css-extract-plugin
export default {"botao":"Button_botao__t6Mpb"};